import { EnterpriseCartEvents, trackGoldStandardEvent } from '@mc/track-event'

export interface trackPropsType {
  action: string
  page_source: string
  location: string
}

export const trackCTAClicked = (trackProps: trackPropsType) => {
  trackGoldStandardEvent(EnterpriseCartEvents.EVENTS.CONTACT_SALES, {
    ...trackProps,
  })
}
